import React, { useCallback, useState } from "react";
import { IdData } from "hooks/FormDesigner/useElementList";
import { useTranslation } from "react-i18next";
import {
	onChangeSearchSelect,
	SearchSelect,
	SearchSelectOptionProps,
} from "@alm/flow-ds/components";
import _ from "lodash";

type Props = {
	additionalSelect?: SearchSelectOptionProps[];
	idList: IdData;
	isEmu?: boolean;
	updateAdditionalSelect: (data: SearchSelectOptionProps[]) => void;
};

export default ({
	additionalSelect,
	idList,
	isEmu,
	updateAdditionalSelect,
}: Props) => {
	const { t } = useTranslation();

	const [selectedValue, setSelectedValue] = useState<
		SearchSelectOptionProps[] | null | undefined
	>(additionalSelect);

	const handleChange = useCallback(
		(value: onChangeSearchSelect) => {
			if (_.isArray(value)) {
				setSelectedValue(value);
				updateAdditionalSelect(value);
			} else {
				const tempArray =
					selectedValue !== undefined && selectedValue !== null
						? selectedValue?.slice()
						: [];
				tempArray.push(value as SearchSelectOptionProps);
				setSelectedValue(tempArray);
				updateAdditionalSelect(tempArray);
			}
		},
		[selectedValue, updateAdditionalSelect]
	);

	return (
		<SearchSelect
			multiselect={true}
			clearable={true}
			onChange={handleChange}
			label={t(`formDesigner.labels.additionalSelect`)}
			options={idList as SearchSelectOptionProps[]}
			value={selectedValue}
			className={!isEmu ? "text-monospace" : ""}
			placeholder={t("formDesigner.placeholders.select")}
			onCreate={input => handleChange({ value: input, label: input })}
		/>
	);
};
